export default {
  namespaced: true,
  custom_timezones: {
    title: "Custom timezone",
    name: "name",
    start: "start",
    end: "end",
    month: "Month",
    day: "Day",
    week: "Week",
    dts: 'Summer time'
  },
};
